module.exports = __webpack_public_path__ + "img/attention.2894ed00.svg";